<template>
  <div class="download-ads-mobile">
    <div class="download-ads-mobile__container">
      <div class="download-ads-mobile__app-info">
        <div class="download-ads-mobile__app-header">
          <div class="download-ads-mobile__app-icon">
            <img class="download-ads-mobile__icon-img" src="@/assets/ads/icon.png" alt="App icon" />
          </div>
          <div class="download-ads-mobile__separator"></div>
          <div class="download-ads-mobile__features">
            <div class="download-ads-mobile__feature">
              <img class="download-ads-mobile__feature-icon" src="@/assets/ads/safe.svg"
                alt="Safety" />
              <div class="download-ads-mobile__feature-name">safety</div>
            </div>
            <div class="download-ads-mobile__feature">
              <img class="download-ads-mobile__feature-icon" src="@/assets/ads/fast.svg"
                alt="Fast" />
              <div class="download-ads-mobile__feature-name">fast</div>
            </div>
            <div class="download-ads-mobile__feature">
              <img class="download-ads-mobile__feature-icon" src="@/assets/ads/noads.svg"
                alt="No Ads" />
              <div class="download-ads-mobile__feature-name">No Ads</div>
            </div>
          </div>
        </div>
        <a class="download-ads-mobile__download" :href="downloadLink" :target="domainConfig?.downloadUrl ? '_blank' : '_self'" rel="noopener noreferrer">
          <div class="download-ads-mobile__download-icon-wrapper">
            <img class="download-ads-mobile__download-icon" src="@/assets/ads/download.png"
              alt="Download" />
          </div>
          <div class="download-ads-mobile__download-text">Download</div>
        </a>
      </div>
      <div class="download-ads-mobile__telegram">
        <div class="download-ads-mobile__telegram-content">
          <div class="download-ads-mobile__telegram-icon-wrapper">
            <img class="download-ads-mobile__telegram-icon" src="@/assets/ads/telegram.svg"
              alt="Telegram" />
          </div>
          <div class="download-ads-mobile__telegram-text">Join the group</div>
        </div>
        <div class="download-ads-mobile__telegram-arrow">›</div>
      </div>
      <div class="download-ads-mobile__social-icons">
        <img class="download-ads-mobile__social-icon" src="@/assets/ads/x.svg" alt="X (Twitter)" />
        <img class="download-ads-mobile__social-icon" src="@/assets/ads/whats.svg" alt="WhatsApp" />
        <img class="download-ads-mobile__social-icon" src="@/assets/ads/ins.svg" alt="Instagram" />
        <img class="download-ads-mobile__social-icon" src="@/assets/ads/face.svg" alt="Facebook" />
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/mixin/common'

export default {
  name: 'DownloadAdsMobile',
  mixins: [common],
  computed: {
    downloadLink() {
      return this.domainConfig?.downloadUrl || '/movie-download/'
    }
  }
};
</script>

<style lang="scss">
@import '@/css/variables.scss';

.download-ads-mobile {
	padding: 0 rem(16);
	margin: rem(20) 0;

	&__container {
		display: flex;
		flex-direction: column;
		gap: rem(10);
		width: 100%;
	}

	&__app-info {
		background: linear-gradient(270deg, rgba(42, 40, 46, 1) 0%, rgba(13, 12, 15, 1) 100%);
		border-radius: rem(28);
		border: 2px solid rgba(255, 255, 255, 0.04);
		padding: rem(16);
		display: flex;
		flex-direction: column;
		gap: rem(16);
		align-items: flex-start;
		justify-content: center;
		width: 100%;
	}

	&__app-header {
		display: flex;
		flex-direction: row;
		gap: rem(16);
		align-items: center;
		justify-content: flex-start;
		width: 100%;
	}

	&__app-icon {
		flex-shrink: 0;
		width: rem(152);
		height: rem(152);
		position: relative;
	}

	&__icon-img {
		border-radius: rem(34);
		border: 1px solid rgba(255, 255, 255, 0.1);
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	&__separator {
		background: #ffffff;
		opacity: 0.1;
		flex-shrink: 0;
		width: 1px;
		height: rem(60);
		position: relative;
	}

	&__features {
		display: flex;
		flex-direction: column;
		gap: rem(8);
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		width: rem(126);
	}

	&__feature {
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
	}

	&__feature-icon {
		flex-shrink: 0;
		width: rem(32);
		height: rem(32);
	}

	&__feature-name {
		color: #ffffff;
		text-align: left;
		font-size: rem(18);
		line-height: rem(20);
		font-weight: 900;
		text-transform: uppercase;
	}

	&__download {
		background: linear-gradient(180deg, rgba(177, 50, 251, 1) 0%, rgba(254, 50, 75, 1) 100%);
		border-radius: rem(24);
		border: 1px solid rgba(255, 255, 255, 0.1);
		padding: rem(18) rem(14);
		display: flex;
		flex-direction: row;
		gap: rem(24);
		align-items: center;
		justify-content: center;
		width: 100%;
		cursor: pointer;
		text-decoration: none;
		color: inherit;
	}

	&__download-icon-wrapper {
		flex-shrink: 0;
		width: rem(22);
		height: rem(24);
		position: relative;
	}

	&__download-icon {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	&__download-text {
		color: #ffffff;
		text-align: left;
		font-size: rem(18);
		line-height: rem(18);
		font-weight: 700;
	}

	&__telegram {
		background: linear-gradient(270deg, rgba(13, 12, 15, 1) 0%, rgba(42, 40, 46, 1) 100%);
		border-radius: rem(24);
		border: 2px solid rgba(255, 255, 255, 0.04);
		padding: rem(16) rem(28);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		width: 100%;
	}

	&__telegram-content {
		display: flex;
		flex-direction: row;
		gap: rem(16);
		align-items: center;
		justify-content: flex-start;
	}

	&__telegram-icon-wrapper {
		flex-shrink: 0;
		width: rem(52);
		height: rem(52);
		position: relative;
	}

	&__telegram-icon {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	&__telegram-text {
		color: #ffffff;
		text-align: left;
		font-size: rem(18);
		line-height: rem(18);
		font-weight: 400;
	}

	&__telegram-arrow {
		color: #ffffff;
		font-size: rem(24);
		line-height: rem(24);
	}

	&__social-icons {
		background: linear-gradient(270deg, rgba(42, 40, 46, 1) 0%, rgba(13, 12, 15, 1) 100%);
		border-radius: rem(24);
		border: 2px solid rgba(255, 255, 255, 0.04);
		padding: rem(16) rem(28);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		width: 100%;
	}

	&__social-icon {
		flex-shrink: 0;
		width: rem(52);
		height: rem(52);
		object-fit: contain;
	}
}
</style> 